   <template>
    <div class="header">
      <div class="left-items" v-if="extended">
        <div class="header-item" @click="showMenu(); extended = false">
          <span class="material-symbols-outlined">menu</span>
        </div>
        <Tooltip text="Edit">
        <div class="header-item" :class="{ active: currentView === 'Edit' }" @click="updateView('Edit'), updateActiveTab('Inspect')">
          <span class="material-symbols-outlined">edit</span>
        </div>
        </Tooltip>
        <Tooltip text="Preview">
        <div class="header-item" :class="{ active: currentView === 'Preview' }" @click="updateView('Preview'), updateViewport('computer'), updateActiveTab('Media')">
          <span class="material-symbols-outlined">preview</span>
        </div>
      </Tooltip>
        <Tooltip text="HTML">
        <div class="header-item" :class="{ active: currentView === 'HTML' }" @click="updateView('HTML'), updateActiveTab('Global')">
          <span class="material-symbols-outlined">code</span>
        </div>
      </Tooltip>
      <Tooltip text="JSON">
        <div class="header-item" :class="{ active: currentView === 'JSON' }" @click="updateView('JSON'), updateActiveTab('Global')">
          <span class="material-symbols-outlined">data_object</span>
        </div>
      </Tooltip>
        <Tooltip text="Block Übersicht">
        <div class="header-item" :class="{ active: currentView === 'Rulesets' }" @click="updateView('Rulesets'), updateActiveTab('Global')">
          <span class="material-symbols-outlined">account_tree</span>
        </div>
      </Tooltip>
        <Tooltip text="Placeholder">
        <div class="header-item" :class="{ active: currentView === 'Mapping' }" @click="updateView('Mapping'), updateActiveTab('Global')">
          <span class="material-symbols-outlined">bolt</span>
        </div>
      </Tooltip>
      </div>
    <div class="left-items" v-else>
      <div class="header-item" @click="closeMenu(); extended= true">
          <span class="material-symbols-outlined">first_page</span>
        </div>
    </div>
      <div class="title">
        <input type="text" v-model="emailTitle" @keydown.enter="handleEnter" />
      </div>
      <div class="right-items">
        
        <div class="header-item" >
          <div class="dropdown">
            <Tooltip text="Sprachauswahl">
              <span class="material-symbols-outlined" @click="showLangDropdown = !showLangDropdown">language</span>
            </Tooltip>
            <div v-if="showLangDropdown" class="language-dropdown">
            <div class="dropdown-item" @click="changeLanguage('en')">EN</div>
            <div class="dropdown-item" @click="changeLanguage('de')">DE</div>
            <div class="dropdown-item" @click="changeLanguage('es')">ES</div>
            <div class="dropdown-item" @click="changeLanguage('ro')">RO</div>
            <div class="dropdown-item" @click="changeLanguage('fr')">FR</div>
          </div>
          </div> 
        </div>
        <Tooltip text="Engine Freigabe">
        <div class="header-item" @click="showEngineModal = true">
          <span class="material-symbols-outlined">engineering</span>
        </div>
      </Tooltip>
        <Tooltip text="Als Mail senden">
        <div class="header-item" @click="showSendEmail = true">
          <span class="material-symbols-outlined">forward_to_inbox</span>
        </div>
      </Tooltip>
        <Tooltip text="Download">
        <div class="header-item download" @click="showSaveFile = true">
          <span class="material-symbols-outlined">download</span>
        </div>
        </Tooltip>
        <div class="header-item download" @click="showRestoreFile = true">
          <span class="material-symbols-outlined">restore_page</span>
        </div>
        <Tooltip text="Save">
        <div v-if="getEmailData.id != 'Guide'" class="header-item" @click="saveEmail">
          <span class="material-symbols-outlined">save</span>
        </div>
        </Tooltip>
        <Tooltip text="Logout">
        <div class="header-item" @click="logout">
            <span class="material-symbols-outlined">logout</span>
        </div>
        </Tooltip>
        <!-- <div class="header-item" @click="getDbMails">
          <span class="material-symbols-outlined"></span>
        </div> -->
      </div>
      <EngineModal  v-if="showEngineModal" @close="showEngineModal = false"/>
      <SaveFile v-if="showSaveFile" @close="showSaveFile = false"/>
      <SendEmail v-if="showSendEmail" @close="showSendEmail = false"/>
      <RestoreFile v-if="showRestoreFile" @close="showRestoreFile = false"/>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import SaveFile from './Reusables/SaveFile.vue';
  import SendEmail from './Reusables/SendEmail.vue';
  import RestoreFile from './Reusables/RestoreFile.vue';
  import EngineModal from './Reusables/EngineModal.vue';
  import { saveEmailToDb } from '@/utils/db/saveEmail';
  
  export default {
    name: 'Header',
    components: { SaveFile, SendEmail, RestoreFile, EngineModal},
    data() {
      return {
        extended: false,
        showSaveFile: false,
        showRestoreFile: false,
        showSendEmail: false,
        showLangDropdown: false,
        showEngineModal: false,
      };
    },
    computed: {
      ...mapGetters(['getView', 'getEmailData', 'getEmailTitle', 'getExampleMail']),
      currentView() {
        return this.getView;
      },
      currentFilePath() {
        return this.getExampleMail;
      },
      emailTitle: {
        get() {
          return this.getEmailTitle;
        },
        set(value) {
          this.updateEmailTitle(value);
        }
      }
    },
    methods: {
      ...mapActions(['updateView', 'saveEmailData', 'updateEmailTitle', 'updateViewport', 'updateActiveTab','updateEmailData', 'setLocale']),
      async saveEmail() {
        try {
          await saveEmailToDb(this.getEmailData); // Warten auf Abschluss der Speicherung
          console.log("E-Mail erfolgreich gespeichert!");
        } catch (error) {
          console.error("Fehler beim Speichern der E-Mail:", error);
        }
      },
   /*    async getDbMails() {
        try {
            const emailDataDb = await buildEmailFromDb(10); 
            this.updateEmailData(emailDataDb); 
            this.updateEmailTitle("test");
          } catch (error) {
            console.error("Fehler beim Abrufen der E-Mail-Daten:", error);
          }
      }, */
      logout() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.reload(); // Nach Logout zur Login-Seite zurückkehren
      },
      handleEnter(event) {
        event.target.blur();
      },
      toggleDropdown() {
      this.showLangDropdown = !this.showLangDropdown;
      },
      changeLanguage(lang) {
      this.setLocale(lang);  // Vuex-Aktion aufrufen, um die Sprache zu setzen
      this.$i18n.locale = lang; // Sprache im i18n-Plugin setzen
      this.showLangDropdown = false; // Dropdown schließen
    },
      showMenu(){
        this.$emit('showMenu')
      },
      closeMenu(){
        this.$emit('closeMenu')
      }
    },
  };
  </script>
  
  <style scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    height: 50px;
    background: linear-gradient(135deg, var(--primary-color) 0, var(--secondary-color) 70%); 
    padding: 0 20px;
    box-shadow: 0px 8px 8px -4px rgba(0, 0, 0, 0.2);
    position: relative;
    /* z-index: 9; Testing for ConfirmationModal*/ 
  }
  
  .left-items, .right-items {
    display: flex;
    align-items: center;
    z-index: 3;
  }

  .header-item {
    cursor: pointer;
    padding: 10px;
    color: white;
    font-size: 24px;
    margin-right: 20px;
    position: relative;
  }
  
  .header-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: white;
  }
  
  .header-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }
  
.title {
  flex-grow: 1;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.title input {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  color: white;
  font-size: 20px;
  text-align: center;
  width: 20%;
  transition: background 0.3s, border-color 0.3s, box-shadow 0.3s;
  display: inline !important;
}

.title input:focus {
  background: white;
  color: black;
  border-color: #05bbef;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 94, 115, 0.5);
}

.language-dropdown {
  position: absolute;
  top: 50px;
  left: 0;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  color: black;
  font-weight: bold;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}
  
  </style>